import React from 'react';
import SEO from '../../../components/SEO';
import TrainingHeader from '../components/TrainingHeader';
import { getCatalogueContent } from '../trainingContent';
import { TRAINING_OFFERS } from '../trainingOffers';
import { getAlternatePaths, getCataloguePath, getOfferPath } from '../trainingRoutes';
import '../training.css';

const copyByLocale = {
  fr: {
    title: 'Formation introuvable',
    seoTitle: 'Formation introuvable | CSL BRANDS',
    description: 'Cette adresse ne correspond à aucun parcours de formation disponible.',
    returnLabel: 'Retour à toutes les formations',
  },
  en: {
    title: 'Training program not found',
    seoTitle: 'Training program not found | CSL BRANDS',
    description: 'This address does not match any available training program.',
    returnLabel: 'Back to all training programs',
  },
};

export const getTrainingNotFoundContent = (locale) => copyByLocale[locale];

export default function TrainingNotFoundPage({ locale }) {
  const content = getCatalogueContent(locale);
  const copy = getTrainingNotFoundContent(locale);
  const cataloguePath = getCataloguePath(locale);

  if (!content || !copy || !cataloguePath) {
    throw new TypeError(`Unsupported training locale: ${locale}`);
  }

  return (
    <div className="training-page training-not-found">
      <SEO
        title={copy.seoTitle}
        description={copy.description}
        path={cataloguePath}
        alternates={getAlternatePaths(cataloguePath)}
      />
      <TrainingHeader locale={locale} />
      <main className="training-not-found__main">
        <h1>{copy.title}</h1>
        <p>{copy.description}</p>
        <a className="training-not-found__catalogue-link" href={cataloguePath}>
          {copy.returnLabel}
        </a>
        <ul className="training-not-found__offers">
          {TRAINING_OFFERS.map((offer) => {
            const card = content.offerCards.find(({ key }) => key === offer.key);

            return (
              <li key={offer.key}>
                <article>
                  <h2>
                    <a href={getOfferPath(locale, offer.key)}>{card.name}</a>
                  </h2>
                  <p>{card.positioning}</p>
                </article>
              </li>
            );
          })}
        </ul>
      </main>
    </div>
  );
}
